module.exports = __webpack_public_path__ + "static/media/TitleLarge.f7647197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oem/TitleLarge.png
// module id = 376
// module chunks = 0